let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
let timeout = false;
let timeout_interval = 1000;

window.addEventListener('load', () => {
    let $thumbs = $('.video-thumbs');

    window.addEventListener('scroll', function () {
        if (window.innerWidth > 768 || iOS) {
            // if (window.innerWidth > 768) {
            return false;
        }
        if ($thumbs.length) {
            $thumbs.each(function (i, elm) {
                let $elm = $(elm);
                let rect = elm.getBoundingClientRect();
                let top = rect.top;
                let bottom = rect.bottom;
                let focus = top >= 0 && bottom <= window.innerHeight;

                if (focus) {
                    displayVideoPreview($elm);
                } else {
                    hideVideoPreview($elm);
                }
            });
        }
    });

    if (!iOS) {
        $thumbs.each(function (i, elm) {
            let $elm = $(elm);

            $elm.on('mouseenter', () => {
                displayVideoPreview($elm);
            });
            $elm.on('mouseleave', () => {
                hideVideoPreview($elm)
            });
        })
    }
});


function displayVideoPreview ($elm) {
    let thumbs_path = $elm.attr('data-path');
    let thumbs_id = $elm.attr('data-id');
    let video_id = 'webm-' + thumbs_id;
    let loader_id = 'loader-' + thumbs_id;
    let webm_extension = $elm.attr('data-extension');
    let thumb_extension = $elm.attr('data-extension');
    let video_path = thumbs_path + '/' + thumbs_id + webm_extension;
    let thumbs_full_path_jpg = thumbs_path + '/' + thumbs_id + '_' + 0 + thumb_extension;

    if ($('#' + video_id).length) {
        return false;
    }

    let $video = $('<video/>');

    $video.attr('id', video_id)
    .attr('class', 'video-webm video-js')
    .attr('preload', "metadata")
    .attr('muted', true)
    .attr('autoplay', true)
    .attr('loop', true)
    .attr('disableRemotePlayback', true)
    .attr('playsinline', "");

    let $source = $('<source/>');

    $source.attr('src', video_path);
    $source.attr('type', "video/webm");

    let $loader = $('<div/>');
    $loader.attr('id', loader_id);
    $loader.attr('class', 'loader-webm');
    if (iOS) {
        $loader.html('<div class="text-primary" role="status" onclick="event.preventDefault()">\n' +
            '  <i class="fa fa-play fa-2x" ontouchstart="$(this).closest(\'.video-thumbs\').find(\'.video-webm\')[0].play()"></i>\n' +
            '</div>');
    } else {
        $loader.html('<div class="spinner-border text-primary" role="status" onclick="event.preventDefault()">\n' +
            '  <span class="sr-only">Loading...</span>\n' +
            '</div>');
    }

    $elm.append($video);
    $elm.append($loader);
    $video.append($source);

    $video.on('loadedmetadata', function () {
        console.log("Can play");
        // $video[0].play();
    });
    $video.on('play', function () {
        $loader.remove();
    });
}

function hideVideoPreview ($elm) {
    let video_id = 'webm-' + $elm.attr('data-id');
    let loader_id = 'loader-' + $elm.attr('data-id');

    $('#' + video_id).remove();
    $('#' + loader_id).remove();
}
